export enum StatusEnum {
  Active = 'TRUE',
  Inactive = 'FALSE',
}

export enum SellerLinkStatus {
  PENDING,
  OFFER_EXPIRED,
  NO_ADVANCE_PAYMENT,
  ADVANCE_PENDING_VALIDATE,
  ADVANCE_COMPLETED,
  VALID_LOAN,
}

export enum SellerLinkIndex {
  FLOW_TRACKING_LIST = 'Flow Tracking List',
  BUYER_LIST = 'Buyers List',
  ADVANCE_PAYMENTS = 'List of Advance Payments',
  SIMULATIONS = 'Simulation List',
  OFFERS = 'Offer List',
  SEMAPHORES = 'Semaphore List',
}

export enum callGroupServBE {
  DASHBOARD = '01-04',
  NOTIFIER = '01-05',
  DOCUMENTS = '01-06',
  LOAN_CALCULATOR = '01-09',
  CLIENT = '01-10',
  FLOW_TRACKING_OFFERS = '01-11',
  SETTINGS = '01-12',
  SEMAPHORE = '01-13',
}

export enum statusResponde {
  STATUS = '0,404,503',
}

export enum callGroupServFE {
  FLOW_TRACKING_PROCESS_ID = '02-02-201',
}

export enum productsFactories {
  products = '03,12,13',
}

export enum productsViewOptions {
  products = '10,14,40,41,42',
}
